import * as React from "react";
import { SVGProps } from "react";
const SvgChevronBoldDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.99 9.97a.997.997 0 0 1-.165.549c-2.755 4.194-6.302 8.312-10.259 11.909a2.362 2.362 0 0 1-3.152 0c-3.956-3.594-7.504-7.712-10.26-11.91a1 1 0 0 1 1.671-1.097c2.666 4.059 6.101 8.044 9.934 11.528a.358.358 0 0 0 .461-.001c3.835-3.485 7.27-7.471 9.933-11.527a1 1 0 0 1 1.83.43l.006.12.001-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronBoldDown;
